import { FC, Fragment } from 'react';
import { v4 as uuid } from 'uuid';
import './LoaderCards.scss';

interface ILoaderCards {
  noCancel?: boolean;
}

const LoaderCards: FC<ILoaderCards> = ({ noCancel }: ILoaderCards) => {
  const cardsList = [1, 2, 3, 4, 5, 6];

  return (
    <>
      <div id="loaderOrdersCards" style={{ height: noCancel ? 'calc(100% - 40px)' : '' }}>
        <div className="containerCards">
          {cardsList.map(() => {
            return (
              <div className="loadCard" key={uuid()}>
                <div className="bodyCard animationLoader" />
              </div>
            );
          })}
        </div>
        <div className="containerCards">
          {cardsList.map(() => {
            return (
              <div className="loadCard" key={uuid()}>
                <div className="bodyCard animationLoader" />
              </div>
            );
          })}
        </div>
        <div className="containerCards">
          {cardsList.map(() => {
            return (
              <div className="loadCard" key={uuid()}>
                <div className="bodyCard animationLoader" />
              </div>
            );
          })}
        </div>
      </div>
      {!noCancel && (
        <div id="horizontalListLoader">
          <div className="titleCancel">Cancelados</div>
          <div className="horizontalCards">
            {cardsList.map(() => {
              return (
                <div className="horizontalCard" key={uuid()}>
                  <div className="boxCard animationLoader"></div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default LoaderCards;
